export default __webpack_public_path__ + "sounds/framework/2decide_R.06e0fa01.mp3?06e0fa01";